import { useState } from 'react'

import { SelectOption } from 'components/Select'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { SupplyChainSlice } from '../../../types'
import { fromDTO, GET_SUPPLY_CHAINS_FOR_FORM, SupplyChainSliceDTO } from './api'
import { Data, Variables } from './api/types'
import { UseGetSupplyChainsForSelect } from './types'

export const useGetSupplyChainsForSelect = (): UseGetSupplyChainsForSelect => {
  const { workspaceId } = useWorkspaceParam()
  const [options, setOptions] = useState<SelectOption<SupplyChainSlice>[]>([])

  useQuery<Variables, Data>({
    onCompleted: async (data: Data): Promise<void> => {
      const {
        supplyChains: { nodes },
      } = data

      if (nodes && nodes.length > 0) {
        setOptions(nodes.map((supplyChain: SupplyChainSliceDTO) => fromDTO(supplyChain)))
      }
    },
    query: GET_SUPPLY_CHAINS_FOR_FORM,
    variables: { workspaceId },
  })

  return options
}
